import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/hotIssue',
  component: LAYOUT,
  name: 'HotIssue',
  redirect: '/hotIssue/qa',
  meta: {
    title: '热门',
  },
  children: [
    {
      path: 'qa',
      name: 'Qa',
      meta: {
        title: '热门QA锦集',
      },
      component: () => import('@/views/hotIssue/qa'),
    },
  ],
};
